import { Badge } from 'react-bootstrap';
import UtilityService from "../services/UtillityServices/UtilityService";

const useRendicontazioneAdminConfigTable = () => {
    
    const getStatoBadge = (stato) => {
        switch (stato) {
            case 'Da Liquidare': return <Badge bg="primary">Da Liquidare</Badge>;
            case 'Verifica Amministrativa': return <Badge bg="warning" text="dark">Verifica Amm.</Badge>;
            case 'Liquidazione Sospesa': return <Badge bg="danger">Sospesa</Badge>;
            default: return <Badge bg="secondary">{stato}</Badge>;
        }
    };

    return [
         {
            key: 'data_aggiornamento',
            label: 'Data Agg.',
            formatter: (value) => UtilityService.formatDate(value),
        },
        {
            key: 'nome_agenzia',
            label: 'Agenzia',
        },
        {
            key: 'periodo',
            label: 'Periodo',
            formatter: (value, row) => `${row.mese}/${row.anno}`,
        },
        {
            key: 'totale_provvigioni',
            label: 'Totale Provvigioni',
            formatter: (value) => `€ ${parseFloat(value).toFixed(2)}`,
            className: 'text-end'
        },
        {
            key: 'stato',
            label: 'Stato',
            formatter: (value) => getStatoBadge(value),
        },
        {
            key: 'fattura',
            label: 'Fattura',
            formatter: (value, row) => (
                <a href={row.path_fattura} target="_blank" rel="noopener noreferrer" className="btn btn-outline-primary btn-sm" title="Visualizza Fattura">
                    <i className="bi bi-download text-info"></i>
                </a>
            ),
            className: 'text-center align-middle'

        }


    ];
};

export default useRendicontazioneAdminConfigTable;